const dateFormat = function (fmt, date) {
    let ret;
    date = new Date(date);
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "i+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    }
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}

const hexToRgb = function (hex, degrees) {
    if (hex.indexOf('rgba(') > -1) {
        hex = hex.split(',');
        hex[3] = degrees + ')';
        return hex.join(',');
    } else {
        hex = hex.toLowerCase()
        if (hex.length === 4) {
            let newColor = '#';
            for (let index = 1; index < 4; index++) {
                newColor += hex.slice(index, index + 1).concat(hex.slice(index, index + 1));
            }
            hex = newColor;
        }
        let rgb = [];
        for (let index = 1; index < 7; index += 2) {
            rgb.push(parseInt(`0x${hex.slice(index, index + 2)}`));
        }
        return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${degrees})`;
    }
    
}

const getQuery = function (variable = null) {
    let query = window.location.href.substring(window.location.href.indexOf('?') + 1);
    let vars = query.split('&');
    let json = {};
    for (let index = 0; index < vars.length; index++) {
        let pair = vars[index].split("=");
        json[pair[0]] = pair[1];
    }
    return variable ? (typeof json[variable] != 'undefined' ? json[variable] : null) : json;
}

const getImageBase64 = function (image) {  
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, image.width, image.height);
    let ext = image.src.substring(image.src.lastIndexOf(".") + 1).toLowerCase();
    let dataURL = canvas.toDataURL("image/" + ext);
    return dataURL.substring(dataURL.indexOf('base64,') + 7);
}

const usableXinhuaVersion = function (targetVersion) {
    let nowVersion = window.navigator.userAgent;
    let nowVersionArr = nowVersion.substring(nowVersion.indexOf('XinHuaNet')).split('/');
    let nowVersionTemp = nowVersionArr.length < 2 || ! nowVersionArr[1] ? '1.0.0' : nowVersionArr[1];
    nowVersionArr = nowVersionTemp.split('.');
    let targetVersionArr = targetVersion.split('.');
    for (let index = 0; index < 3; index++) {
        // 长度不一样时补充后导零
        let nowLength = nowVersionArr[index].length;
        let targetLength = nowVersionArr[index].length;
        if (nowLength > targetLength) {
            targetVersionArr[index].padEnd(nowLength, 0);
        } else if (nowLength < targetLength) {
            nowLength[index].padEnd(targetLength, 0);
        }
        let now = Number(nowVersionArr[index]);
        let target = Number(targetVersionArr[index]);
        if (now < target) {
            return false;
        }
    }
    return true;
}

export default {
    dateFormat,
    hexToRgb,
    getQuery,
    getImageBase64,
    usableXinhuaVersion
}